export const markers = {

    namespaced: true,

    state:{
        markersHidro: true,
        markersAcele: true,
        markersPhrea: true,
        markersAirq: true,
        allMarkers: true,
        newKey: 0
    },

    mutations:{
        Modify_Marker_Group(state,index){
            if(state.allMarkers){
                state.allMarkers = false;
                switch(index){
                    case 0:
                        state.markersAcele = false;
                        state.markersPhrea = false;
                        state.markersAirq = false;
                        break;
                    case 1:
                        state.markersHidro = false;
                        state.markersPhrea = false;
                        state.markersAirq = false;
                        break;
                    case 2:
                        state.markersHidro = false;
                        state.markersAcele = false;
                        state.markersAirq = false;
                        break;
                    case 3:
                        state.markersHidro = false;
                        state.markersAcele = false;
                        state.markersPhrea = false;
                        break;
                    case 4:
                        state.allMarkers = false;
                        state.markersHidro = false;
                        state.markersAcele = false;
                        state.markersPhrea = false;
                        state.markersAirq = false;
                        break;
                }
            }else{
                switch(index){
                    case 0:
                        state.markersHidro = !state.markersHidro;
                        state.newKey ++;
                        break;
                    case 1:
                        state.markersAcele = !state.markersAcele;
                        break;
                    case 2:
                        state.markersPhrea = !state.markersPhrea;
                        break;
                    case 3:
                        state.markersAirq = !state.markersAirq;
                        break;
                    case 4:
                        state.allMarkers = true;
                        state.markersHidro = true;
                        state.markersAcele = true;
                        state.markersPhrea = true;
                        state.markersAirq = true;
                        state.newKey ++;
                        break;
                }
                if(state.markersHidro && state.markersAcele && state.markersPhrea && state.markersAirq){
                    state.allMarkers = true;
                }
            }
        }
    }
};